
import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import EspecialidadeIcon from "../../assets/icons/servicos.png";
import EspecialidadesService from "../../services/EspecialidadesService";

export default function EspecialidadesForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idEspecialidade: null,
    descricao: "",
    tempo: "",
    valor: "",
    ativo: true,
    interno: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idEspecialidade: null,
        descricao: "",
        tempo: "",
        valor: "",
        ativo: true,
        interno: false,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idEspecialidade: itemSelecionado.IDESPECIALIDADE,
        descricao: itemSelecionado.DESCRICAO,
        tempo: itemSelecionado.TEMPO,
        valor: itemSelecionado.valor,
        ativo: itemSelecionado.ATIVO,
        interno: itemSelecionado.INTERNO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.descricao) e.descricao = "Informe a descrição";
    if (!form.tempo) e.tempo = "Informe o tempo";
    if (!form.valor) e.valor = "Informe o valor";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {
        const payload_create = { 
          DESCRICAO: form.descricao,
          TEMPO: form.tempo,
          valor: form.valor,
          ATIVO: form.ativo,
          INTERNO: form.interno
        };
        await EspecialidadesService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Especialidade criada com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {
        const payload_update = { 
          DESCRICAO: form.descricao,
          TEMPO: form.tempo,
          VALOR: form.valor,
          ATIVO: form.ativo,
          INTERNO: form.interno
         };
        await EspecialidadesService.update(
          form.idEspecialidade,
          payload_update
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Especialidade atualizada com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar especialidade."
            : "Erro ao atualizar especialidade.",
      });

      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={EspecialidadeIcon} alt="" className="icon" />
          {modo === "novo"
            ? "Cadastro de Especialidade"
            : "Alterar Especialidade"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tempo: *</div>
          <input
            placeholder="Tempo em minutos"
            name="tempo"
            value={form.tempo}
            onChange={handleChange}
          />
          {errors.tempo && (
            <span style={{ color: "red" }}>{errors.tempo}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor: *</div>
          <input
            placeholder="0,00"
            name="valor"
            value={form.valor}
            onChange={handleChange}
          />
          {errors.valor && (
            <span style={{ color: "red" }}>{errors.valor}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Interno</div>
            <select
              name="interno"
              value={String(form.interno)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
        </div>    


        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div> 
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
